import React from 'react'
import styled from '@emotion/styled'
import { withTheme } from 'emotion-theming'
import { array, object, string } from 'prop-types'

//components and utils imports
import { Carousel } from '@jelly/components'
import HeroBanner from 'components/HeroBanner'
import CardQuoteStyled from 'components/CardQuoteStyled'

//styled components
const TestimonialsWrapper = styled.div`
	height: 100%;
	max-width: 100%;
	position: relative;
	width: 100%;
	min-height: 650px;
	background-color: ${({ theme }) => theme.colors.lightGrey};
	${({ theme }) => theme.MQ.M} {
		min-height: 900px;
	}
	@media (min-width: 1000px) and (max-width: 1300px) {
		min-height: 850px;
	}
	@media (min-width: 240px) and (max-width: 300px) {
		min-height: 780px;
	}
`
const HeroWrapper = styled.div`
	display: none;
	${({ theme }) => theme.MQ.M} {
		display: block;
	}
`
const TitleWrapper = styled.div`
	${({ theme }) => theme.header.h2};
	color: ${({ theme }) => theme.colors.navy};
	padding-top: 20px;
	${({ theme }) => theme.MQ.M} {
		font-size: 34px;
		font-weight: 500;
		color: #fff;
		padding-top: 80px;
	}
`
const SubTitleWrapper = styled.div`
	${({ theme }) => theme.text.bodyLarge};
	color: ${({ theme }) => theme.colors.darkGrey};
	${({ theme }) => theme.MQ.M} {
		color: #fff;
	}
`
const HeaderWrapper = styled.div`
	text-align: center;
	display: block;
	${({ theme }) => theme.MQ.M} {
		display: none;
	}
`

const CarouselContainer = styled.div`
	left: 0;
	margin: 60px auto 0 auto;
	max-width: 860px;
	position: absolute;
	right: 0;
	top: 10%;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		top: 30%;
	}

	${({ theme }) => theme.MQ.MAX} {
		top: 40%;
	}

	@media (min-width: 1050px) {
		top: 29%;
	}
`
Testimonials.propTypes = {
	background: string.isRequired,
	listTestimonials: array.isRequired,
	subTitle: string.isRequired,
	theme: object.isRequired,
	title: string.isRequired,
}
function Testimonials({ background, listTestimonials, subTitle, theme, title }) {
	return (
		<TestimonialsWrapper>
			<HeroWrapper>
				<HeroBanner
					height="40vh"
					background={background}
					overlayColor="#000000"
					overlayOpacity=".30"
					bgPosition="0 45%"
					maxBgPosition="0 35%"
					align="center"
				>
					<TitleWrapper>{title}</TitleWrapper>
					<SubTitleWrapper>{subTitle}</SubTitleWrapper>
				</HeroBanner>
			</HeroWrapper>
			<HeaderWrapper>
				<TitleWrapper>{title}</TitleWrapper>
				<SubTitleWrapper>{subTitle}</SubTitleWrapper>
			</HeaderWrapper>
			<CarouselContainer>
				<Carousel
					elements={listTestimonials.map((element) => {
						return <CardQuoteStyled {...element} />
					})}
					fillDotColor={theme.colors.orange}
					borderColor={theme.colors.teal}
				/>
			</CarouselContainer>
		</TestimonialsWrapper>
	)
}
export default withTheme(Testimonials)
